import { ICreateRequestDto } from 'common/dto/RequestDto';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { IProcedure } from 'common/schema/Procedure';
import { FormikContextType } from 'formik';
import { sortBy } from 'lodash';
import { WidgetGraphicType } from '../graphic/WidgetGraphic';
import { IWidget } from '../Widget';
import { WidgetDisposal } from './WidgetDisposal';
import { WidgetDisposalLogic } from './WidgetDisposalLogic';

export interface IWidgetFormStep {
  title: string;
  disposal: WidgetDisposal;
  widgets: IWidget[];
}

/**
 * Gestisce la disposizione in "Step" all'interno del form.
 */
export class WidgetDisposalStepLogic {
  /** Suddivide i widget in steps in base ai widget */
  static splitWidgetInSteps(widgets: IWidget[]) {
    const result: { title: string; widgets: IWidget[] }[] = [];
    // Per ogni widget se è un divider crea un nuovo step
    // altrimenti continua a elencarli
    widgets.forEach((widget, index) => {
      if (widget.graphic?.type === WidgetGraphicType.Divider) {
        result.push({ title: widget.graphic.content ?? '', widgets: [] });
      } else {
        // Se il primo elemento non è un divider, crea una sezione apposita di default
        if (index === 0) {
          result.push({ title: 'Compilazione', widgets: [] });
        }
        // Aggiungo in coda all'ultima sezione
        result[result.length - 1].widgets.push(widget);
      }
    });
    return result;
  }

  static getSteps(procedure: IProcedure) {
    let steps: IWidgetFormStep[] = [];

    const sortedWidgets = sortBy(procedure.widgets, 'order');
    const splitWidgets = WidgetDisposalLogic.split(sortedWidgets);

    const splitWidgetList = WidgetDisposalStepLogic.splitWidgetInSteps(
      splitWidgets.Free
    );

    // Per ogni sezione creo uno step
    splitWidgetList.forEach((item, index) => {
      steps.push({
        title: item.title,
        disposal: WidgetDisposal.Free,
        widgets: [
          ...item.widgets,
          // Gli elementi fixed li metto in fondo all'ultimo step
          ...(index === splitWidgetList.length - 1
            ? splitWidgets[WidgetDisposal.Fixed]
            : [])
        ]
      });
    });

    if (splitWidgets[WidgetDisposal.Step].length > 0) {
      steps.push({
        title: 'Verifica e inoltro',
        disposal: WidgetDisposal.Step,
        widgets: splitWidgets[WidgetDisposal.Step]
      });
    }

    return steps;
  }

  /**
   * Ottiene gli errori per i Widget visualizzati nello Step corrente
   */
  static getStepErrors(
    step: IWidgetFormStep,
    formik: FormikContextType<ICreateRequestDto>
  ) {
    const metadatas = MetadataLogic.fromWidgets(step.widgets);
    return metadatas
      .filter(m => formik.errors.values?.[m.id] != null)
      .map(m => ({ metadata: m, error: formik.errors.values?.[m.id]! }));
  }
}
